'use client';

import { usePromotionsAvailability } from '@/modules/promotions/hooks/usePromotionsAvailability';
import { useGetCommonStore } from '@/store';
import { checkHeadlinePromoCountryMatch } from './helpers/checkHeadlinePromoCountryMatch';

export const useActiveHeadlinePromoConfig = () => {
  const useCommonStore = useGetCommonStore();
  const configs = useCommonStore.use.headlinePromoConfigs();
  const user = useCommonStore.use.user();
  const countryCode = useCommonStore.use.countryCode();
  const { isHeadlinePromoAvailable } = usePromotionsAvailability();

  return configs.find(
    (config) =>
      isHeadlinePromoAvailable(config.promoKey) &&
      checkHeadlinePromoCountryMatch(
        config.allowedCountries,
        config.disallowedCountries,
        user?.country || countryCode
      )
  );
};
